export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["यह क्रिया एसेट को स्थायी रूप से हटा देगी"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्या आप वाकई जारी रखना चाहते हैं?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["हाँ"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रद्द करें"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आप इस एसेट को अपनी सूची में अब नहीं देख पाएंगे।"])}
}